import {injectable} from 'inversify';

import type {CourseModel} from './Course.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class CourseController extends BaseController<CourseModel> {
  constructor() {
    super();
  }
}
